import { styled } from 'styled-components'
import media from 'common-ui-components/src/vtj/theme/media'

export const LoadingSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 320px;
  ${media.mobileMaxWidth} {
    height: 500px;
  }
`
